import React from "react";
import { Row, Col, FormGroup, Card, CardBody, Button, Table, ButtonToolbar } from "reactstrap";

import { connect } from "react-redux";
import { searchTrend } from "../../datautils/actions/adminActions";
import PanelHeader from "../../components/PanelHeader/PanelHeader";

import { ADMIN_TREND_VIEW } from "../../utils/constants/clientUrls";
import CustomPagination from "../../components/CustomPagination/CustomPagination";
import { sortIcon } from "../../utils/constants/icons";
import { PER_PAGE } from "../../utils/constants/index";
import ErrorBlock from "../../components/ErrorBlock/ErrorBlock";

class TrendList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      globalSearchKeyword: "",
      pageNumber: 1,
      pageSize: PER_PAGE,
      sortField: "trendId",
      ascending: false,
      currentTab: "",
    };
  }

  componentDidMount() {
    this.searchData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.searchData();
    }
  }

  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.setState(
        {
          pageNumber: 1,
        },
        () => this.searchData()
      );
    }
  };

  searchButton = (e) => {
    this.setState(
      {
        pageNumber: 1,
      },
      () => this.searchData()
    );
  };

  sortButton = (field, order) => (e) => {
    e.preventDefault();

    this.setState(
      {
        sortField: field,
        ascending: order,
      },
      () => this.searchData()
    );
  };

  searchHandler = (e) => {
    this.setState({ globalSearchKeyword: e.target.value });
  };

  filterData = (e) => {
    this.setState(
      {
        currentTab: e.target.value,
        globalSearchKeyword: "",
        pageNumber: 1,
      },
      () => this.searchData()
    );
  };

  searchData = () => {
    const { globalSearchKeyword, currentTab, pageNumber, pageSize, sortField, ascending } = this.state;

    const reqData = {
      globalSearchKeyword,
      fieldNameKeyword: [{ key: "status", operation: "EQUAL_TO", value: currentTab }],
      paginationOptions: {
        pageNumber,
        pageSize,
        sortOptions: [{ sortField, ascending }],
      },
    };
    this.props.searchTrend(reqData);
  };

  handleChange = (input) => () => {
    this.props.history.push(ADMIN_TREND_VIEW + "/" + input);
  };

  changePage = (page) => () => {
    this.setState({ pageNumber: page });
  };

  renderPagination = () => {
    const mainData = this.props.responseVal.dObjectData.trendList.data;
    if (mainData.totalNoOfPages > 1) {
      return (
        <CustomPagination
          pageNumber={this.state.pageNumber}
          totalNoOfPages={mainData.totalNoOfPages}
          changePage={this.changePage}
          hasPrevious={mainData.hasPrevious}
          hasNext={mainData.hasNext}
        />
      );
    }
  };

  render() {
    const { responseVal } = this.props;
    const { globalSearchKeyword, ascending, pageNumber, pageSize, currentTab } = this.state;

    const dataLoaded =
      responseVal.dObjectData.trendList &&
      responseVal.dObjectData.trendList.data &&
      responseVal.dObjectData.trendList.data.trends
        ? responseVal.dObjectData.trendList.data.trends
        : false;

    return (
      <div>
        <PanelHeader />
        <div className="content">
          <Row>
            <Col xs={12}>
              {responseVal.errors && responseVal.status === "failure" ? (
                <ErrorBlock errors={responseVal.errors} />
              ) : null}
            </Col>
            <Col xs={8}>
              <ButtonToolbar>
                {" "}
                <Button size="sm" value="1" onClick={this.filterData} color={currentTab === "1" ? "primary" : ""}>
                  ACTIVE
                </Button>
                <Button size="sm" value="0" onClick={this.filterData} color={currentTab === "0" ? "primary" : ""}>
                  INACTIVE
                </Button>
                <Button size="sm" value="" onClick={this.filterData} color={currentTab === "" ? "primary" : ""}>
                  ALL
                </Button>
              </ButtonToolbar>{" "}
            </Col>
            <Col xs={4}>
              <Button
                size="sm"
                className="float-right"
                onClick={() => this.props.history.push(ADMIN_TREND_VIEW)}
                color="success"
              >
                Create New Trend
              </Button>
            </Col>
            <Col xs={12}>
              <Card>
                <CardBody className="listings">
                  <React.Fragment>
                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <div className="has-search">
                            <div className="input-group">
                              <input
                                type="search"
                                value={globalSearchKeyword}
                                name="globalSearchKeyword"
                                className="form-control"
                                placeholder="Search Trend..."
                                onChange={this.searchHandler}
                                onKeyDown={this.handleKeyDown}
                                style={{ background: "#f5f5f5" }}
                                autoComplete="off"
                              />
                              <div className="input-group-append">
                                <Button color="primary" onClick={this.searchButton}>
                                  <i className="now-ui-icons ui-1_zoom-bold" />
                                </Button>
                              </div>
                            </div>
                          </div>
                        </FormGroup>
                      </Col>
                      <Col md="8">{dataLoaded ? this.renderPagination() : ""}</Col>
                    </Row>

                    <Table responsive className="table-striped table-bordered">
                      <thead>
                        <tr className="text-primary">
                          <th className="text-center">#</th>

                          <th onClick={this.sortButton("trendId", ascending ? false : true)}>
                            Trend ID <img alt="sort" className="sort-icon" src={sortIcon} />
                          </th>
                          <th>Summary </th>
                          <th>Category</th>
                          <th>Tags</th>
                          <th>Display Name</th>
                          <th onClick={this.sortButton("displayPriorityStatus", ascending ? false : true)}>
                            Display Priority <img alt="sort" className="sort-icon" src={sortIcon} />
                          </th>
                          <th>User Group Type </th>
                          <th onClick={this.sortButton("likesCount", ascending ? false : true)}>
                            Likes <img alt="sort" className="sort-icon" src={sortIcon} />
                          </th>
                          <th>Status </th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dataLoaded ? (
                          dataLoaded.length ? (
                            dataLoaded.map((row, index) => {
                              const cname =
                                row.status === "ACTIVE"
                                  ? "success"
                                  : row.status === "INACTIVE"
                                  ? "danger"
                                  : row.status === "ONHOLD"
                                  ? "warning"
                                  : "primary";
                              return (
                                <tr key={index}>
                                  <td className="text-center">{pageNumber * pageSize + (index + 1) - pageSize}</td>
                                  <td onClick={this.handleChange(row.trendId)} className="cursor">
                                    {row.trendId}
                                  </td>
                                  <td onClick={this.handleChange(row.trendId)} className="cursor">
                                    {row.summary}
                                  </td>
                                  <td>{row.catIdsIdentifierLabel.join(" / ")}</td>
                                  <td>{row.tags.join(", ")}</td>
                                  <td>{row.authorDisplayName}</td>
                                  <td>{row.displayPriorityStatus}</td>
                                  <td>{row.userGroupType}</td>
                                  <td>{row.likesCount}</td>
                                  <td>{row.status}</td>

                                  <td className="text-right">
                                    <Button
                                      className={`btn-simple btn-light btn-${cname}`}
                                      size="xs"
                                      onClick={this.handleChange(row.trendId)}
                                    >
                                      Edit
                                    </Button>{" "}
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="11" className="no-data">
                                No data available
                              </td>
                            </tr>
                          )
                        ) : (
                          <tr>
                            <td colSpan="11" />
                          </tr>
                        )}
                      </tbody>
                    </Table>
                    {this.props.isLoading ? <div className="loader" /> : null}
                  </React.Fragment>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.ui.isLoading,
    responseVal: state.resHandlerVal,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    searchTrend: (reqData) => dispatch(searchTrend(reqData)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrendList);
